import { render, staticRenderFns } from "./ViPaymentHistory.vue?vue&type=template&id=6ee83e8b&scoped=true"
import script from "./ViPaymentHistory.vue?vue&type=script&lang=js"
export * from "./ViPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./ViPaymentHistory.vue?vue&type=style&index=0&id=6ee83e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee83e8b",
  null
  
)

export default component.exports